import { IPropsWithChildren } from '@omaze/app';
import React, { ReactElement } from 'react';

import styles from './Page.module.css';
import { pageDisplayName } from './Page.qa';

export interface IPageProps extends IPropsWithChildren {
    className?: string;
    'data-testid'?: string;
}

export function OzPage (props: IPageProps): ReactElement {
    const {
        className = '',
        children,
        'data-testid': dataTestId,
    }: IPageProps = props;

    return (
        <div className={`${className} ${styles.host} mx-auto px-2 flex flex-wrap lg:px-3`} data-testid={dataTestId}>
            {children}
        </div>
    );
}

OzPage.displayName = pageDisplayName;
